import React, { useCallback, useEffect, useState } from "react";
import { HeroSm, MyInput, NavBar, Spinner } from "../../components";
import { Footer } from "../../layouts";
import $ from "jquery";
import { Slang } from "../../helpers";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../store";
import axios from "axios";
import { fetchWrapper } from "../../helpers/fetch-wrapper";
import config from "../../config";

const SendCode = () => {
  const [loadPage, setLoadPage] = useState(true);

  useEffect(() => {
    const tim2 = setTimeout(() => {
      setLoadPage(false);
    }, 100);

    return () => {
      clearTimeout(tim2);
    };
  }, []);

  return (
    <>
      {loadPage ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100%",
            position: "fixed",
            left: 0,
            top: 0,
          }}
        >
          <Spinner color={"success"} size={3} />
        </div>
      ) : (
        <Main />
      )}
    </>
  );
};

const Main = () => {
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [data, setData] = useState({
    ip: "",
    email: "",
  });

  const lang = Slang("resetPassword");
  const langRegister = Slang("Register");
  const pInfoLang = Slang("Register.PersonnalsInfo");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value.trim() });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    const ip = sessionStorage.getItem("ip");

    try {
      const response = await axios.post(
        `${config.apiUrl}/user/reset-password`,
        { ...data, ip_address: ip },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("response", response);
      setSubmitted(false);
      storeUserInfo(response.data.data);
      // navigate("/verify-otp");
    } catch (error) {
      setSubmitted(false);
      console.log("Error:", error);
      navigate("/verify-otp");
      const message = error.response.data.exception.message;
      if (message.includes("Here is your 6-digit code: **")) {
        navigate("/verify-otp");
      }
    }

    // await axios
    //   .post(`${config.apiUrl}/user/reset-password`, { ...data, ip })
    //   .then((response) => {
    //     console.log("Response:", response);
    //     setSubmitted(true);
    //     storeUserInfo(response.data);
    //     navigate("/verify-otp");
    //   })
    //   .catch((error) => {
    //     setSubmitted(false);
    //     console.error("Error:", error);
    //   });
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   setSubmitted(true);
  //   const ip = sessionStorage.getItem("ip");
  //   fetchWrapper
  //     .post(`${config.apiUrl}/user/reset-password`, { data, ip })
  //     .then((response) => {
  //       setSubmitted(false);
  //       storeUserInfo(response.data);
  //       navigate("/verify-otp");
  //     })
  //     .catch((e) => {
  //       setSubmitted(false);
  //     });
  // };

  const storeUserInfo = (data) => {
    dispatch(authActions.setToken(data.token));
    dispatch(authActions.setUser(data.user));
    dispatch(authActions.setIsAuth(false));
  };

  const getIpAddress = () => {
    axios
      .get("https://api.ipify.org/?format=json")
      .then((response) => {
        sessionStorage.setItem("ip", response.data.ip);
        setData({ ...data, ip: response.data.ip });
      })
      .catch((error) => {
        console.error("Error fetching IP:", error);
      });
  };

  useEffect(() => {
    const script = `
            new HSGoTo('.js-go-to');
            new HSHeader('#header').init();
            new HSMegaMenu('.js-mega-menu', {"desktop": {"position": "left"}});
        `;

    $("body").append(`<script className="homescript">${script}</script>`);

    getIpAddress();

    return () => {
      $(".homescript").remove();
    };
  }, []);

  return (
    <>
      <NavBar />
      <HeroSm title={lang("t1")} />
      <main id="content" role="main">
        <div className="container content-space-3 content-space-t-lg-1 content-space-b-lg-3">
          <div className="flex-grow-1 mx-auto" style={{ maxWidth: "28rem" }}>
            <div className="text-center mb-5 mb-md-7">
              <h1 className="h2">
                <img
                  src="./assets/img/logos/155x47/initial/PNG/init_gradient.png"
                  alt="logo"
                  style={{ height: "7vh" }}
                />
              </h1>
            </div>
            <form
              onSubmit={handleSubmit}
              className="js-validate needs-validation"
            >
              <div className="mb-3">
                <MyInput
                  required
                  handleChange={handleChange}
                  id="email"
                  name="email"
                  placeholder="email@site.com"
                  type="email"
                  label={pInfoLang("t4")}
                />
              </div>
              <br />
              <div className="d-grid mb-3 col-md-12 col-sm-12">
                <button
                  disabled={submitted}
                  type="submit"
                  className="btn btn-primary btn-lg"
                >
                  {submitted ? <Spinner color="light" /> : lang("t2")}
                </button>
              </div>
            </form>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default SendCode;

// const SendCode = () => {
//   const [loadPage, setLoadPage] = useState(true);
//   useEffect(() => {
//     let tim2 = setTimeout(() => {
//       setLoadPage(false);
//     }, 100);

//     return () => {
//       clearInterval(tim2);
//     };
//   }, []);

//   return (
//     <>
//       {loadPage ? (
//         <>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               justifyContent: "center",
//               alignItems: "center",
//               height: "100vh",
//               width: "100%",
//               position: "fixed",
//               left: 0,
//               top: 0,
//             }}
//           >
//             <Spinner color={"success"} size={3} />
//           </div>
//         </>
//       ) : (
//         <Main />
//       )}
//     </>
//   );
// };

// export default SendCode;

// const Main = () => {
//   const [submitted, setSubmitted] = useState(false);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   dispatch(authActions.logout());
//   const [data, setData] = useState({
//     ip: "",
//     email: "",
//   });
//   const lang = Slang("resetPassword");
//   const langRegister = Slang("Register");
//   const pInfoLang = Slang("Register.PersonnalsInfo");

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setData({ ...data, [name]: value.trim() });
//   };
// const handleSubmit = (e) => {
//   e.preventDefault();
//   setSubmitted(true);
//   const ip = sessionStorage.getItem("ip");
//   fetchWrapper
//     .post(`${config.apiUrl}/user/reset-password`, { data, ip })
//     .then((response) => {
//       setSubmitted(false);
//       storeUserInfo(response.data);
//       navigate("/verify-otp");
//     })
//     .catch((e) => {
//       setSubmitted(false);
//     });
// };

//   const storeUserInfo = (data) => {
//     dispatch(authActions.setToken(data.token));
//     dispatch(authActions.setUser(data.user));
//     dispatch(authActions.setIsAuth(false));
//   };

//   const getIpAddress = () => {
//     axios.get("https://api.ipify.org/?format=json").then((response) => {
//       sessionStorage.setItem("ip", response.data.ip);
//       setData({ ...data, ip: response.data.ip });
//     });
//   };

//   useEffect(() => {
//     const script = `
//             new HSGoTo('.js-go-to');
//             new HSHeader('#header').init();
//             new HSMegaMenu('.js-mega-menu', {"desktop": {"position": "left"}});
//         `;

//     $("body").append(`<script className="homescript">${script}</script>`);

//     getIpAddress();

//     return () => {
//       $(".homescript").remove();
//     };
//   }, []);
//   return (
//     <>
//       {/*{window.location.pathname === "add-business" ? <NavBar /> : null}*/}
//       <NavBar />
//       <HeroSm title={lang("t1")} />
//       <main id="content" role="main">
//         <div className="container content-space-3 content-space-t-lg-1 content-space-b-lg-3">
//           <div className="flex-grow-1 mx-auto" style={{ maxWidth: "28rem" }}>
//             <div className="text-center mb-5 mb-md-7">
//               <h1 className="h2">
//                 <img
//                   src="./assets/img/logos/155x47/initial/PNG/init_gradient.png"
//                   alt="logo"
//                   style={{ height: "7vh" }}
//                 />
//               </h1>
//             </div>

//             <form
//               onSubmit={handleSubmit}
//               className="js-validate needs-validation"
//             >
//               <div className="mb-3">
//                 <MyInput
//                   required
//                   handleChange={handleChange}
//                   id="email"
//                   name="email"
//                   placeholder="email@site.com"
//                   type="email"
//                   label={pInfoLang("t4")}
//                 />
//               </div>
//               <br />
//               <div className="d-grid mb-3 col-md-12 col-sm-12">
//                 <button
//                   disabled={submitted}
//                   type="submit"
//                   className="btn btn-primary btn-lg"
//                 >
//                   {submitted ? <Spinner color="light" /> : lang("t2")}
//                 </button>
//               </div>
//             </form>
//             {/*<div className="text-center">*/}
//             {/*    <p>{langRegister("t9")} <Link className="link" to="/register">{langRegister("10")}</Link></p>*/}
//             {/*    <p><Link className="link" to="/forgot-password">{langRegister("11")}</Link></p>*/}
//             {/*</div>*/}
//           </div>
//         </div>
//       </main>
//       <Footer />
//     </>
//   );
// };
